import { ref, computed } from "vue";
import { storeToRefs } from "pinia";

import { useAccountsStore } from "@stores/accounts";
import { useCurrentUserStore } from "@/stores/currentUser";
import { useRolesStore } from "@/stores/roles";
import { userType } from "@utils/constants/userRoles";
import { createFilters } from "@/utils/composables/filters/createFilters";

const userTypeFilter = ref<string[]>([]);
const roleFilter = ref<number[]>([]);
const accountFilter = ref<number[]>([]);

export const useUsersFilters = () => {
  const accountsStore = useAccountsStore();
  const currentUserStore = useCurrentUserStore();
  const rolesStore = useRolesStore();

  const { accounts } = storeToRefs(accountsStore);
  const { roleOptions } = storeToRefs(rolesStore);
  const { isClient, isSuperAdmin } = storeToRefs(currentUserStore);

  const userTypeOptions = computed(() => {
    const baseTypes = [
      { label: "Admin", value: userType.ADMIN },
      { label: "Sales", value: userType.SALES },
      { label: "Client", value: userType.CLIENT },
    ];

    if (isSuperAdmin.value) baseTypes.unshift({ label: "Super Admin", value: userType.SUPER_ADMIN });

    return baseTypes;
  });

  const accountOptions = computed(() => accounts.value?.map(({ name, id }) => ({ label: name, value: id })) || []);

  return {
    ...createFilters({
      filters: [
        {
          id: "userType",
          label: "Type",
          options: userTypeOptions,
          model: userTypeFilter,
          when: () => !isClient.value,
        },
        {
          id: "role",
          label: "Role",
          options: roleOptions,
          model: roleFilter,
        },
        {
          id: "account",
          label: "Account",
          hasSearch: true,
          options: accountOptions,
          model: accountFilter,
          when: () => !isClient.value,
        },
      ],
    }),
    userTypeFilter,
    roleFilter,
    accountFilter,
  };
};
